import React, { Component } from 'react';
import {Row, Col} from 'reactstrap'

const isOnLOP = require('../utilities/isOnLOP');
const sprintf = require('sprintf-js').sprintf;
const R = require('ramda');

class StudentHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {showSchedule: false}
    this.changeFlag = this.changeFlag.bind(this);
    this.toggleSchedule = this.toggleSchedule.bind(this);
  }

  getOnOffClass(flag) {
    return (flag) ? "on-lop" : "off-lop-green"
  }

  changeFlag(type) {
    let _this = this;
    return evt => {
      if (type === 'finance') {
        _this.props.db.ref('students/'+_this.props.student.stuID+'/finance').set(!_this.props.student.finance);
      } else if (type === 'library') {
        _this.props.db.ref('students/'+_this.props.student.stuID+'/library').set(!_this.props.student.library);
      }
    }
  }

  toggleSchedule() {
    this.setState({showSchedule: !this.state.showSchedule})
  }

  render() {
    let s = this.props.student;

    let acGPAText = (!s) ? '' : ((s.acGPA === '') ? '---' : sprintf('%5.2f', parseFloat(s.acGPA)));
    let acGPAClass = (acGPAText === '---') ? 'off-lop' : ((acGPAText < 2.00) ? 'on-lop' : 'off-lop-green');
    let citGPAText = (!s) ? '' : ((s.citGPA === '') ? '---' : sprintf('%5.2f', parseFloat(s.citGPA)));
    let citGPAClass = (citGPAText === '---') ? 'off-lop' : ((citGPAText < 2.00) ? 'on-lop' : 'off-lop-green');
    let onLOP = isOnLOP(s);
    let isAugust = (new Date()).getMonth() === 7;
    let scheduleText;
    if (isAugust) {
      scheduleText = <span>Schedules are available after Sept 1</span>
    } else if (this.state.showSchedule) {
      scheduleText = <span onClick={this.toggleSchedule} className="link bold">Hide schedule</span>
    } else {
      scheduleText = <span onClick={this.toggleSchedule} className="link bold">Show schedule</span>
    }
    let schedules = null;
    if (this.props.schedules) {
      schedules = (this.props.schedules) ? R.sort((a, b) => (a.period + a.course < b.period + b.course) ? -1 : 1, this.props.schedules) : [];
      schedules = R.groupBy(s => s.termName, schedules);
      schedules = R.reduce((html, key) => {
        let s = schedules[key]
        let forEachIdx = R.addIndex(R.forEach);
        html.push(<Row key={"sem"+key} className="student-details term"><Col>{"Term: "+key}</Col></Row>);
        forEachIdx((schedule, idx) =>
            html.push(
              <Row key={'sched' + schedule.termName + idx} className="student-details">
                <Col md={4}>{R.take(20, schedule.course)}</Col>
                <Col className="text-center" md={2}>{schedule.period}</Col>
                <Col className="text-center" md={2}>{schedule.room}</Col>
                <Col md={4}>{R.take(20, schedule.teacher)}</Col>
              </Row>
            )
          , s)
        html.push(<hr/>);
        return html;
      }, [], R.keys(schedules));
    }

    return (
      (s) ?
        <div>
          <Row>
            <Col md={8} className={(onLOP) ? 'on-lop' : 'off-lop-green'}>
              <h5>{s.lastName+', '+s.firstName+' ('+s.stuID+')'}</h5>
            </Col>
            <Col md={4} className="text-right">
              <h5>C/O {s.classOf} | Gr: {s.grade}</h5>
            </Col>
          </Row>
          <Row className="student-details">
            <Col md={4}><span className="bold">Counselor:</span>{' '+s.counselor}</Col>
            <Col md={4} className="text-center">
              <span className={acGPAClass}>AcGPA: {acGPAText}</span>
              <span> | </span>
              <span className={citGPAClass}>CitGPA: {citGPAText}</span>
            </Col>
            <Col md={4} className="text-right cursor-pointer" title={(this.props.user.permissionFlags.UPDATE_LIBRARY === 'true' || this.props.user.permissionFlags.UPDATE_FINANCE === 'true') ? "Click to change status" : ''}>
              <span onClick={(this.props.user.permissionFlags.UPDATE_LIBRARY === 'true') ? this.changeFlag('library') : null} className={this.getOnOffClass(s.library)}>Lib:</span><span onClick={(this.props.user.permissionFlags.UPDATE_LIBRARY === 'true') ? this.changeFlag('library') : null} className={this.getOnOffClass(s.library)}>{` \u2588`}</span>
              <span> | </span>
              <span onClick={(this.props.user.permissionFlags.UPDATE_FINANCE === 'true') ? this.changeFlag('finance') : null} className={this.getOnOffClass(s.finance)}>Fin:</span><span onClick={(this.props.user.permissionFlags.UPDATE_FINANCE === 'true') ? this.changeFlag('finance') : null} className={this.getOnOffClass(s.finance)}>{` \u2588`}</span>
            </Col>
          </Row>
          <Row className="student-details schedule-top-margin">
            <Col md={12}>
              {scheduleText}
            </Col>
          </Row>
          {
            (this.state.showSchedule) ?
              <Row className="student-details">
                <Col md={4} className='bold'>Course</Col>
                <Col md={2} className='text-center bold'>Per</Col>
                <Col md={2} className='text-center bold'>Room</Col>
                <Col md={4} className="bold">Teacher</Col>
              </Row> : null
          }
          {
            (this.state.showSchedule) ? schedules : null
          }
        </div> : <h4 className="text-center">No student to display</h4>
    )
  }

}

export default StudentHeader



// WEBPACK FOOTER //
// ./src/views/StudentHeader.js